import React from "react";
import "./App.css";
import ApplicationRoutes from "./ApplicationRoutes";

function App() {
  return (
    <div>
      <ApplicationRoutes />
    </div>
  );
}

export default App;
